import { FC, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { TeamContext, UserContext } from "../context";
import { Loader } from "../components/atoms";
import { LobbyPage } from "../pages";
import { Phase } from "../util/enums";

const LobbyRoute: FC<{}> = () => {
    const { teamNumber, game, urlToken, gameId } = useContext(TeamContext);
    const { userData } = useContext(UserContext);
    let history = useHistory();

    useEffect(() => {
        if (teamNumber && userData && game?.phase === Phase.SLOT_MACHINE)
        history.push("/slotmachine/" + urlToken);
    }, [game?.phase, history, teamNumber, urlToken, userData, gameId]);

    const conditionToRenderLobby = teamNumber && userData && (game?.phase === Phase.LOBBY || game?.phase === Phase.LOBBY_READY);

    useEffect(() => {
        if (userData) return;

        const timeout = setTimeout(() => {
            history.push("/logIn/" + urlToken);
        }, 2000);

        return () => clearTimeout(timeout);
    }, [userData, history, urlToken]);

    return (
        <div>
            {userData && <Loader />}
            {/* {!conditionToRenderLobby && <div style={{color: "white"}}> try with another email </div> } */}
             <LobbyPage />
        </div>
    );

}

export default LobbyRoute;